import React from "react";
import { isMobile } from "../../../utils/_helper";

import "./FetchLoader.css";

const FetchLoader = ({ text }) => {
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
              .main-mobile-bg {
                background: none;
              }
              .sticky-on-med {
                background: none;
              }
              .mobile-back-btn-header {
                background-color: transparent!important;
              }
              `,
        }}
      />
      {isMobile() ? (
        <>
          <div className="loader__container">
            <div className="loadingContainer">
              <div className="ball1"></div>
              <div className="ball2"></div>
              <div className="ball3"></div>
              <div className="ball4"></div>
            </div>

            <div className="loader-text">Loading...</div>
          </div>
        </>
      ) : (
        <div className="fetch-content">
          <div className="loading">
            <p>{text}</p>
            <span></span>
          </div>
        </div>
      )}
    </>
  );
};

export default FetchLoader;
